/*
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-07 14:36:36
 * @LastEditTime: 2020-04-14 08:54:16
 * @Description: 前台页面路由
 */
import ProductList from '@/pages/front/product-list/product-list';
import Single from '@/pages/front/single/info';
// import ToolList from '@/pages/front/tool-list/tool-list'
const routes = [
    {
      name:"产品列表",
      path: "/product-list",
      component: ProductList
    },
    {
      name:"免责声明",
      path: "/info/:id",
      component: Single
    }
    // ,
    // {
    //   path: "/tool-list",
    //   component: ()=>import("@/pages/front/components/layout.vue"),
    //   children:[
    //     {
    //       path: "/info",
    //       component: ()=>import("@/pages/front/components/info.vue"),
    //     }
    //   ]
    // }
];
export default routes;



// WEBPACK FOOTER //
// ./src/router/front.js